import { Link } from 'react-router-dom';
import { useSeo } from '../seo/seo';
import { NOT_FOUND_SEO } from '../seo/site';

export function NotFoundPage() {
  useSeo(NOT_FOUND_SEO);

  return (
    <section className="not-found" aria-labelledby="not-found-title">
      <p className="eyebrow">404</p>
      <h1 id="not-found-title">페이지를 찾을 수 없습니다.</h1>
      <p>주소를 다시 확인하거나 홈에서 필요한 계산기를 찾아보세요.</p>
      <Link className="text-link" to="/">
        홈으로 돌아가기
      </Link>
    </section>
  );
}
